// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3NFMY","amount":"Amount_amount__jdKqE","tip":"Amount_tip__RaK3d","tipHeader":"Amount_tipHeader__2xRYh","tipsWrap":"Amount_tipsWrap__1pIJp"};